import { Component, OnInit, ChangeDetectorRef,EventEmitter,Output ,Input, ViewChild,ElementRef} from '@angular/core';
import { Instore, ExcelInstore } from '@app/_services/Instore'; 
import { ExcelService } from '@app/_services/excel.service';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { InstoreService } from '@app/_services'; 
import { first } from 'rxjs/operators';
import * as moment from 'moment'; 
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-bulkupload',
  templateUrl: './bulkupload.component.html', 
  styleUrls: ['./bulkupload.component.css']
})

export class BulkuploadComponent implements OnInit {
  @ViewChild("file") fileInput: ElementRef;
  isLoading = false;
  private format = 'YYYY-MM-DD';

  importInstore: ExcelInstore[] = [];
  exportInstore: Instore[] = [];
  filterString = "";

  _instoreLists: Instore[] = [];
  _instore_bulk_lists: Instore[] = [];
  _instore_bulk_error_lists: Instore[] = [];
  dataForExcel = [];

  page = 1;
  pageSize = 15;
  email="";
  
  nModule = 1; //1 for Validate, 2 for Upload

  constructor(private excelSrv: ExcelService, private instoreService: InstoreService,private modalService: NgbModal, private toastr: ToastrService) { }

  ngOnInit(): void {
    //this.refreshRecognitions()
  }
  onFileChange(evt: any) {
    this.nModule = 1;

    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      let data = <any[]>this.excelSrv.importFromFile(bstr);
      data= data.filter(item => !(Array.isArray(item) && item.length === 0));
      const header: string[] = Object.getOwnPropertyNames(new ExcelInstore());
      const importedData = data.slice(1);

      const nonEmptyRows = importedData.filter(row => {
        debugger;
        var empty = row.some(cell => cell !== null && cell !== undefined && cell.trim() !== "");
        return empty;
      });
      

      this.importInstore = nonEmptyRows.map(arr => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return <ExcelInstore>obj;
      })
      this.loadInstoreForDisplay();
      //console.log("onFileChange ----"+this.importInstore.length+"---");

      this.fileInput.nativeElement.value = "";
    };
    reader.readAsBinaryString(target.files[0]);

  }

  loadInstoreForDisplay() {
    this._instoreLists = []
    for(var i=0; i<this.importInstore.length;i++) {
          var tempImport = this.importInstore[i];
          debugger;
          let tempInstore = {
            name: tempImport.name, 
            region: tempImport.region,   
            showroom: tempImport.showroom,
            floor: tempImport.floor,
            location: tempImport.location,
            asset_type: tempImport.assets, 
            creative: tempImport.creative.replace(/\s+$/, ''),
            particulars: tempImport.particulars, 
            size_w: tempImport.size_w,
            size_h: tempImport.size_h,
            asset_count: "",
            install_date: this.dateConversion(tempImport.installation_date),
            expiry_date:this.dateConversion(tempImport.expiry_date),
            // expiry_date: moment(tempImport.expiry_date).format(this.format),
            image: tempImport.image,
            vendor: tempImport.vendor
          };   
          
          this._instoreLists.push(tempInstore);
    }
  }
  public dateConversion(date){
   return moment(date, 'yyyy-MM-dd').add(1, 'hours').format(this.format)
  }

  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
    }
  }
  excelDateToJSDate(excelDate) {
    var date = new Date(Math.round((excelDate - (25567 + 1)) * 86400 * 1000));
    var converted_date = date.toISOString().split('T')[0];
    return converted_date;
  }


  submitText() {
    if(this.nModule == 1) {
      return "Validate";
    } else {
      return "Upload";
    }
  }

  submitButtonClicked(modalID) {
    if(this.nModule == 1) {
      this.validateInstore();
    } else {
      this.uploadInstore(modalID);
    }
  }

  localeValidation() {
    var isStopService = false;
    var emptyRegion = this._instoreLists.filter(function (e) {return e.region == null || e.region == "";});  
    if(emptyRegion.length > 0) { isStopService = true; this.toastr.warning("Region could not be empty", "Warning", {timeOut: 10000}); }

    var emptyShowroom = this._instoreLists.filter(function (e) {return e.showroom == null || e.showroom == "";}); 
    if(emptyShowroom.length > 0) { isStopService = true; this.toastr.warning("Showroom could not be empty", "Warning", {timeOut: 10000}); }

    var emptyFloor = this._instoreLists.filter(function (e) {return e.floor == null || e.floor == "";}); 
    if(emptyFloor.length > 0) { isStopService = true; this.toastr.warning("Floor could not be empty", "Warning", {timeOut: 10000});  }

    var emptyLocation = this._instoreLists.filter(function (e) {return e.location == null || e.location == "";}); 
    if(emptyLocation.length > 0) { isStopService = true; this.toastr.warning("Location could not be empty", "Warning", {timeOut: 10000}); }

    var emptyType= this._instoreLists.filter(function (e) {return e.asset_type == null || e.asset_type == "";}); 
    if(emptyType.length > 0) { isStopService = true; this.toastr.warning("Asset type could not be empty", "Warning", {timeOut: 10000}); }

    var emptyCreatives = this._instoreLists.filter(function (e) {return e.creative == null || e.creative == "";}); 
    if(emptyCreatives.length > 0) { isStopService = true; this.toastr.warning("Creative could not be empty", "Warning", {timeOut: 10000}); }

    var emptyParticular = this._instoreLists.filter(function (e) {return e.particulars == null || e.particulars == "";}); 
    if(emptyParticular.length > 0) { isStopService = true; this.toastr.warning("Particulars could not be empty", "Warning", {timeOut: 10000}); }

    var emptyWidth = this._instoreLists.filter(function (e) {return e.size_w == null || e.size_w == "";}); 
    if(emptyWidth.length > 0) { isStopService = true; this.toastr.warning("Size width could not be empty", "Warning", {timeOut: 10000}); }

    var emptyHeight = this._instoreLists.filter(function (e) {return e.size_h == null || e.size_h == "";}); 
    if(emptyHeight.length > 0) { isStopService = true; this.toastr.warning("Size height could not be empty", "Warning", {timeOut: 10000}); }

    var emptyName = this._instoreLists.filter(function (e) {return e.name == null || e.name == "";}); 
    if(emptyName.length > 0) { isStopService = true; this.toastr.warning("Instore name could not be empty", "Warning", {timeOut: 10000}); }

    var emptyVendor = this._instoreLists.filter(function (e) {return e.vendor == null || e.vendor == "";}); 
    if(emptyVendor.length > 0) { isStopService = true; this.toastr.warning("Vendor could not be empty", "Warning", {timeOut: 10000}); }

    var emptyInstallation = this._instoreLists.filter(function (e) {return e.install_date == null || e.install_date == "";}); 
    if(emptyInstallation.length > 0) { isStopService = true; this.toastr.warning("Installation date could not be empty", "Warning", {timeOut: 10000}); }

    var emptyExpiry = this._instoreLists.filter(function (e) {return e.expiry_date == null || e.expiry_date == "";}); 
    if(emptyExpiry.length > 0) { isStopService = true; this.toastr.warning("Expiry date could not be empty", "Warning", {timeOut: 10000}); }
    return isStopService;                                                                 
  }

  validateInstore() {
    if(this.localeValidation()) {
       return;
    }

    this.isLoading = true;
    let tempMessage = {
      type: "validate",
      instoredata: this._instoreLists
    }
    console.log("----iii----"+JSON.stringify(tempMessage))
  
    this.instoreService.validateBulkInstore(JSON.stringify(tempMessage))
    .pipe(first())
      .subscribe(
      (response) => {
        debugger;
        this._instoreLists = response.results;
        console.log("----iii----"+JSON.stringify(this._instoreLists))

        this.checkForApprovedInstore();
        this.isLoading = false;
      },
      (error) => {     
        this.isLoading = false;
      }
    );

  }

  checkForApprovedInstore() {
    this._instore_bulk_lists = []
    this._instore_bulk_error_lists=[];
    for(var i=0; i<this._instoreLists.length;i++) {
          var tempImport = this._instoreLists[i];
          if(this.checkForGreen(tempImport)) {
                let tempInstore = {
                  name: tempImport.name, 
                  region: tempImport.region,   
                  showroom: tempImport.showroom,
                  floor: tempImport.floor,
                  location: tempImport.location,
                  asset_type: tempImport.asset_type, 
                  creative: tempImport.creative, 
                  size_w: tempImport.size_w,
                  size_h: tempImport.size_h,
                  asset_count: "1",
                  install_date: tempImport.install_date,
                  expiry_date: tempImport.expiry_date,
                  particulars: tempImport.particulars,
                  image:tempImport.image,
                  vendor: tempImport.vendor,
                  region_id: tempImport.region_id,
                  showroom_id: tempImport.showroom_id,
                  floor_id: tempImport.floor_id,
                  location_id: tempImport.location_id,
                  asset_type_id: tempImport.asset_type_id,
                  creative_id: tempImport.creative_id,
                  vendor_id: tempImport.vendor_id
                };   
                this._instore_bulk_lists.push(tempInstore);
          }else{
                this._instore_bulk_error_lists.push(tempImport)
          } 
    }

     if(this._instore_bulk_lists.length > 0 && this._instore_bulk_error_lists.length==0) {
      this.nModule = 2;  
     }
     //this.downloadExcel();
  
    if(this._instore_bulk_error_lists.length>0){
      this.excelSrv.exportAsExcelFile_( this._instore_bulk_error_lists, 'error_instore_data');
    }
  }
downloadExcel(){
  // this._instoreLists.forEach((row: any) => {
  //   this.dataForExcel.push(Object.values(row))
  // })
  // console.log("--dataForExcel- - -"+JSON.stringify( this.dataForExcel));
  // const header =  Object.keys(this._instoreLists[0])
  // const data =  this.dataForExcel;

  // console.log("--data- - -"+JSON.stringify(data));

  // let workbook = new Excel.Workbook();
  // let worksheet = workbook.addWorksheet('Instore Data');
  // let headerRow = worksheet.addRow(header);
  // headerRow.eachCell((cell, number) => {
  //   cell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: '4167B8' },
  //     bgColor: { argb: '' }
  //   }
  //   cell.font = {
  //     bold: true,
  //     color: { argb: 'FFFFFF' },
  //     size: 12
  //   }
  // })
  // data.forEach(d => {
  //   let row = worksheet.addRow(d);
  //   let sales = row.getCell(2);
  //   let color = 'FF99FF99';
  //   sales.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: color }
  //   }
  // }
  // );
  // worksheet.getColumn(3).width = 20;
  // worksheet.addRow([]);
  // workbook.xlsx.writeBuffer().then((data) => {
  //   let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //   fs.saveAs(blob, "title" + '.xlsx');
  // })

}
  uploadInstore(modalID) {
    this.isLoading = true;

    let tempMessage = {
      type: "import",
      instoredata: this._instore_bulk_lists
    }

    this.instoreService.uploadBulkInstore(JSON.stringify(tempMessage))
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;

       // console.log("uploadBulkInstore Resposne "+response.state);
        if(response.state==="ERROR"){
          this.toastr.error("Please try again", "Error", {timeOut: 10000});
        }else{
          this.nModule = 1;
          this._instoreLists = [];
          this.isLoading = false;
          this.openModal(modalID);
        }
      },
      (error) => {     
        this.isLoading = false;
       // console.log("uploadBulkInstore Error "+error);                          
      }
    );

  }

  checkForGreen(instore: Instore) {
    if((parseInt(instore.id) > 0) && (parseInt(instore.region_id) > 0) && (parseInt(instore.showroom_id) > 0) && (parseInt(instore.floor_id) > 0) && (parseInt(instore.location_id) > 0) && (parseInt(instore.asset_type_id) > 0) && (parseInt(instore.creative_id) > 0) && (parseInt(instore.vendor_id) > 0)) {
      return true;
    } else {
      return false;
    }

  }

  exportData(tableId: string) {
    this.excelSrv.exportToFile("instore", tableId);
  }

  
  closeResult :string
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}

